import gql from 'graphql-tag';

export const _GET_LEGAL_ENTITIES = gql`
	query getLegalEntities($participant: uuid) {
		legal_entities: risolto_legal_entity(where: { participant: { _eq: $participant } }) {
			reference
			registration_name
			company_id
			logical_id
		}
	}
`;
